import React from "react";
import { Button, Container, Row } from "react-bootstrap";
import { FaEnvelope, FaLinkedin } from "react-icons/fa";
import Particle from "../Particle";

function ResumeNew() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container className="resume-page-content">
        <Row className="justify-content-center text-center">
          <h1 className="project-heading">
            Lokesh Khandelwal <strong className="purple">Resume</strong>
          </h1>
          <p className="resume-page-subtitle">
            Long-term Working Student Software Engineering profile with full-stack experience, education, and Founding Engineer (Pre-Launch Product) prototype work.
          </p>
        </Row>

        <Row className="justify-content-center resume-actions">
          <Button href="mailto:lokesh1911e@gmail.com" className="resume-action-btn">
            <FaEnvelope /> Request CV
          </Button>
          <Button
            href="https://www.linkedin.com/in/lokesh1911e/"
            target="_blank"
            rel="noopener noreferrer"
            className="resume-action-btn resume-action-secondary"
          >
            <FaLinkedin /> LinkedIn Profile
          </Button>
        </Row>

        <div className="resume-frame-wrap">
          <div className="resume-frame-toolbar">
            <span>
              Working Student Software Engineering CV
            </span>
          </div>
          <div className="resume-placeholder">
            <h2>Updated CV available on request</h2>
            <p>
              My current profile combines M.Sc. Web & Data Science studies in Koblenz,
              full-stack software engineering experience, long-term Germany intent, and selected pre-launch product engineering work.
            </p>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default ResumeNew;
